export const filterOptionList = [
    {
        label: 'Recent',
        value: 1
    },
    {
        label: 'Name',
        value: 2
    },
]

export const countryList = [
    {
        label: 'Japanese',
        value: 'japanese',
        checked: false,
    },
    {
        label: 'Filipino',
        value: 'filipino',
        checked: false,
    },
    {
        label: 'Italian',
        value: 'italian',
        checked: false,
    },
    {
        label: 'Taiwanese',
        value: 'taiwanese',
        checked: false,
    },
    {
        label: 'American',
        value: 'american',
        checked: false,
    },
    {
        label: 'French',
        value: 'french',
        checked: false,
    },
    {
        label: 'Chinese',
        value: 'chinese',
        checked: false,
    },
    {
        label: 'Korean',
        value: 'korean',
        checked: false,
    },
    {
        label: 'Thai',
        value: 'thai',
        checked: false,
    },
    {
        label: 'Vietnam',
        value: 'vietnam',
        checked: false,
    },
]

export const dishList = [
    {
        label: 'Sushi',
        value: 'sushi',
        checked: false,
    },
    {
        label: 'Ramen',
        value: 'ramen',
        checked: false,
    },
    {
        label: 'Cafe',
        value: 'cafe',
        checked: false,
    },
    {
        label: 'Dessert',
        value: 'dessert',
        checked: false,
    },
    {
        label: 'Salad',
        value: 'salad',
        checked: false,
    },
    {
        label: 'Udon',
        value: 'udon',
        checked: false,
    },
    {
        label: 'Pizza',
        value: 'pizza',
        checked: false,
    },
    {
        label: 'Cakes',
        value: 'cakes',
        checked: false,
    },
    {
        label: 'Burgers',
        value: 'burgers',
        checked: false,
    },
    {
        label: 'Donut',
        value: 'donut',
        checked: false,
    },
    {
        label: 'Pasta',
        value: 'pasta',
        checked: false,
    },
    {
        label: 'Samgyeopsal',
        value: 'samgyeopsal',
        checked: false,
    },
    {
        label: 'Steak',
        value: 'steak',
        checked: false,
    },
    {
        label: 'Syabusyabu',
        value: 'syabusyabu',
        checked: false,
    },
    {
        label: 'Tonkatu',
        value: 'tonkatu',
        checked: false,
    },
    {
        label: 'BBQ',
        value: 'bbq',
        checked: false,
    },
    {
        label: 'Fruits',
        value: 'fruits',
        checked: false,
    },
    {
        label: 'Bar',
        value: 'bar',
        checked: false,
    },
    {
        label: 'Izakaya',
        value: 'izakaya',
        checked: false,
    },
    {
        label: 'Buffe',
        value: 'buffe',
        checked: false,
    },
]

export const facilityList = [
    {
        label: 'No Specific Seat',
        value: 'no-specific-seat'
    },
    {
        label: 'Table',
        value: 'table'
    },
    {
        label: 'Room',
        value: 'room'
    },
]

export const voucherList = [
    {
        label: 'Japanese',
        value: 1
    },
    {
        label: 'Filipino',
        value: 2
    },
    {
        label: 'Taiwanese',
        value: 3
    },
    {
        label: 'American',
        value: 4
    },
    {
        label: 'French',
        value: 5
    },
    {
        label: 'Chinese',
        value: 6
    },
    {
        label: 'Korean',
        value: 7
    },
    {
        label: 'Thai',
        value: 8
    },
    {
        label: 'Vietnam',
        value: 9
    },
]

export const galleryData = [
    {
        id: 1,
        name: 'Filipino',
        imageUrl: '/img/front/img_filipino.jpg'
    },
    {
        id: 2,
        name: 'Japanese',
        imageUrl: '/img/front/img_japanese.jpg'
    },
    {
        id: 3,
        name: 'Italian',
        imageUrl: '/img/front/img_italian.jpg'
    },
    {
        id: 4,
        name: 'Taiwanese',
        imageUrl: '/img/front/img_taiwanese.jpg'
    },
    {
        id: 5,
        name: 'Italian',
        imageUrl: '/img/front/img_italian.jpg'
    },
    {
        id: 6,
        name: 'Taiwanese',
        imageUrl: '/img/front/img_taiwanese.jpg'
    },
    {
        id: 7,
        name: 'Italian',
        imageUrl: '/img/front/img_italian.jpg'
    },
    {
        id: 8,
        name: 'Taiwanese',
        imageUrl: '/img/front/img_taiwanese.jpg'
    },
]

export const commentData: any = [
    {
        id: 1,
        name: 'Jese Leos',
        profileUrl: '/img/store-details/img_store-04.png',
        body: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
        rating: 4,
        datePosted: new Date(),
        liked_count: 110,
        disliked_count: 2,
        images: [
            {
                name: 'restaurant',
                imageUrl: '/img/store-details/img_store-01.jpg',
            },
            {
                name: 'restaurant',
                imageUrl: '/img/store-details/img_store-01.jpg',
            },
            {
                name: 'restaurant',
                imageUrl: '/img/store-details/img_store-01.jpg',
            },
            {
                name: 'restaurant',
                imageUrl: '/img/store-details/img_store-01.jpg',
            }
        ]
    },
    {
        id: 2,
        name: 'Jese Leos',
        profileUrl: '/img/store-details/img_store-04.png',
        body: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
        rating: 4,
        datePosted: new Date(),
        liked_count: 110,
        disliked_count: 2,
        images: [
            {
                name: 'restaurant',
                imageUrl: '/img/store-details/img_store-01.jpg',
            },
            {
                name: 'restaurant',
                imageUrl: '/img/store-details/img_store-01.jpg',
            },
            {
                name: 'restaurant',
                imageUrl: '/img/store-details/img_store-01.jpg',
            },
            {
                name: 'restaurant',
                imageUrl: '/img/store-details/img_store-01.jpg',
            }
        ]
    },
    {
        id: 3,
        name: 'Jese Leos',
        profileUrl: '/img/store-details/img_store-04.png',
        body: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
        rating: 4,
        datePosted: new Date(),
        liked_count: 110,
        disliked_count: 2,
        images: [
            {
                name: 'restaurant',
                imageUrl: '/img/store-details/img_store-01.jpg',
            },
            {
                name: 'restaurant',
                imageUrl: '/img/store-details/img_store-01.jpg',
            },
            {
                name: 'restaurant',
                imageUrl: '/img/store-details/img_store-01.jpg',
            },
            {
                name: 'restaurant',
                imageUrl: '/img/store-details/img_store-01.jpg',
            }
        ]
    },
    {
        id: 4,
        name: 'Jese Leos',
        profileUrl: '/img/store-details/img_store-04.png',
        body: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
        rating: 4,
        datePosted: new Date(),
        liked_count: 110,
        disliked_count: 2,
        images: [
            {
                name: 'restaurant',
                imageUrl: '/img/store-details/img_store-01.jpg',
            },
            {
                name: 'restaurant',
                imageUrl: '/img/store-details/img_store-01.jpg',
            },
            {
                name: 'restaurant',
                imageUrl: '/img/store-details/img_store-01.jpg',
            },
            {
                name: 'restaurant',
                imageUrl: '/img/store-details/img_store-01.jpg',
            }
        ]
    },
    {
        id: 5,
        name: 'Jese Leos',
        profileUrl: '/img/store-details/img_store-04.png',
        body: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
        rating: 4,
        datePosted: new Date(),
        liked_count: 110,
        disliked_count: 2,
        images: [
            {
                name: 'restaurant',
                imageUrl: '/img/store-details/img_store-01.jpg',
            },
            {
                name: 'restaurant',
                imageUrl: '/img/store-details/img_store-01.jpg',
            },
            {
                name: 'restaurant',
                imageUrl: '/img/store-details/img_store-01.jpg',
            },
            {
                name: 'restaurant',
                imageUrl: '/img/store-details/img_store-01.jpg',
            }
        ]
    },
    {
        id: 6,
        name: 'Jese Leos 2',
        profileUrl: '/img/store-details/img_store-04.png',
        body: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
        rating: 4,
        datePosted: new Date(),
        liked_count: 110,
        disliked_count: 2,
        images: [
            {
                name: 'restaurant',
                imageUrl: '/img/store-details/img_store-01.jpg',
            },
            {
                name: 'restaurant',
                imageUrl: '/img/store-details/img_store-01.jpg',
            },
            {
                name: 'restaurant',
                imageUrl: '/img/store-details/img_store-01.jpg',
            },
            {
                name: 'restaurant',
                imageUrl: '/img/store-details/img_store-01.jpg',
            }
        ]
    },
    {
        id: 7,
        name: 'Jese Leos 1',
        profileUrl: '/img/store-details/img_store-04.png',
        body: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
        rating: 4,
        datePosted: new Date(),
        liked_count: 110,
        disliked_count: 2,
        images: [
            {
                name: 'restaurant',
                imageUrl: '/img/store-details/img_store-01.jpg',
            },
            {
                name: 'restaurant',
                imageUrl: '/img/store-details/img_store-01.jpg',
            },
            {
                name: 'restaurant',
                imageUrl: '/img/store-details/img_store-01.jpg',
            },
            {
                name: 'restaurant',
                imageUrl: '/img/store-details/img_store-01.jpg',
            }
        ]
    },
    {
        id: 8,
        name: 'Jese Leos',
        profileUrl: '/img/store-details/img_store-04.png',
        body: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
        rating: 4,
        datePosted: new Date(),
        liked_count: 110,
        disliked_count: 2,
        images: [
            {
                name: 'restaurant',
                imageUrl: '/img/store-details/img_store-01.jpg',
            },
            {
                name: 'restaurant',
                imageUrl: '/img/store-details/img_store-01.jpg',
            },
            {
                name: 'restaurant',
                imageUrl: '/img/store-details/img_store-01.jpg',
            },
            {
                name: 'restaurant',
                imageUrl: '/img/store-details/img_store-01.jpg',
            }
        ]
    },
    {
        id: 9,
        name: 'Jese Leos',
        profileUrl: '/img/store-details/img_store-04.png',
        body: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
        rating: 4,
        datePosted: new Date(),
        liked_count: 110,
        disliked_count: 2,
        images: [
            {
                name: 'restaurant',
                imageUrl: '/img/store-details/img_store-01.jpg',
            },
            {
                name: 'restaurant',
                imageUrl: '/img/store-details/img_store-01.jpg',
            },
            {
                name: 'restaurant',
                imageUrl: '/img/store-details/img_store-01.jpg',
            },
            {
                name: 'restaurant',
                imageUrl: '/img/store-details/img_store-01.jpg',
            }
        ]
    },
    {
        id: 10,
        name: 'Jese Leos',
        profileUrl: '/img/store-details/img_store-04.png',
        body: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
        rating: 4,
        datePosted: new Date(),
        liked_count: 110,
        disliked_count: 2,
        images: [
            {
                name: 'restaurant',
                imageUrl: '/img/store-details/img_store-01.jpg',
            },
            {
                name: 'restaurant',
                imageUrl: '/img/store-details/img_store-01.jpg',
            },
            {
                name: 'restaurant',
                imageUrl: '/img/store-details/img_store-01.jpg',
            },
            {
                name: 'restaurant',
                imageUrl: '/img/store-details/img_store-01.jpg',
            }
        ]
    },
    {
        id: 11,
        name: 'Jese Leos',
        profileUrl: '/img/store-details/img_store-04.png',
        body: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
        rating: 4,
        datePosted: new Date(),
        liked_count: 110,
        disliked_count: 2,
        images: [
            {
                name: 'restaurant',
                imageUrl: '/img/store-details/img_store-01.jpg',
            },
            {
                name: 'restaurant',
                imageUrl: '/img/store-details/img_store-01.jpg',
            },
            {
                name: 'restaurant',
                imageUrl: '/img/store-details/img_store-01.jpg',
            },
            {
                name: 'restaurant',
                imageUrl: '/img/store-details/img_store-01.jpg',
            }
        ]
    },
    {
        id: 12,
        name: '5 Jese Leos',
        profileUrl: '/img/store-details/img_store-04.png',
        body: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
        rating: 4,
        datePosted: new Date(),
        liked_count: 110,
        disliked_count: 2,
        images: [
            {
                name: 'restaurant',
                imageUrl: '/img/store-details/img_store-01.jpg',
            },
            {
                name: 'restaurant',
                imageUrl: '/img/store-details/img_store-01.jpg',
            },
            {
                name: 'restaurant',
                imageUrl: '/img/store-details/img_store-01.jpg',
            },
            {
                name: 'restaurant',
                imageUrl: '/img/store-details/img_store-01.jpg',
            }
        ]
    },
    {
        id: 13,
        name: '2 Jese Leos',
        profileUrl: '/img/store-details/img_store-04.png',
        body: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
        rating: 4,
        datePosted: new Date(),
        liked_count: 110,
        disliked_count: 2,
        images: [
            {
                name: 'restaurant',
                imageUrl: '/img/store-details/img_store-01.jpg',
            },
            {
                name: 'restaurant',
                imageUrl: '/img/store-details/img_store-01.jpg',
            },
            {
                name: 'restaurant',
                imageUrl: '/img/store-details/img_store-01.jpg',
            },
            {
                name: 'restaurant',
                imageUrl: '/img/store-details/img_store-01.jpg',
            }
        ]
    },
    {
        id: 14,
        name: '3 Jese Leos',
        profileUrl: '/img/store-details/img_store-04.png',
        body: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
        rating: 4,
        datePosted: new Date(),
        liked_count: 110,
        disliked_count: 2,
        images: [
            {
                name: 'restaurant',
                imageUrl: '/img/store-details/img_store-01.jpg',
            },
            {
                name: 'restaurant',
                imageUrl: '/img/store-details/img_store-01.jpg',
            },
            {
                name: 'restaurant',
                imageUrl: '/img/store-details/img_store-01.jpg',
            },
            {
                name: 'restaurant',
                imageUrl: '/img/store-details/img_store-01.jpg',
            }
        ]
    },
    {
        id: 15,
        name: 'Jese Leos',
        profileUrl: '/img/store-details/img_store-04.png',
        body: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
        rating: 4,
        datePosted: new Date(),
        liked_count: 110,
        disliked_count: 2,
        images: [
            {
                name: 'restaurant',
                imageUrl: '/img/store-details/img_store-01.jpg',
            },
            {
                name: 'restaurant',
                imageUrl: '/img/store-details/img_store-01.jpg',
            },
            {
                name: 'restaurant',
                imageUrl: '/img/store-details/img_store-01.jpg',
            },
            {
                name: 'restaurant',
                imageUrl: '/img/store-details/img_store-01.jpg',
            }
        ]
    },
    {
        id: 16,
        name: 'Jese Leos',
        profileUrl: '/img/store-details/img_store-04.png',
        body: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
        rating: 4,
        datePosted: new Date(),
        liked_count: 110,
        disliked_count: 2,
        images: [
            {
                name: 'restaurant',
                imageUrl: '/img/store-details/img_store-01.jpg',
            },
            {
                name: 'restaurant',
                imageUrl: '/img/store-details/img_store-01.jpg',
            },
            {
                name: 'restaurant',
                imageUrl: '/img/store-details/img_store-01.jpg',
            },
            {
                name: 'restaurant',
                imageUrl: '/img/store-details/img_store-01.jpg',
            }
        ]
    }
]

export const areaData: any = [
    {
        id: 0,
        slides: [
            { 
                id: 1,
                key: 'metro-manila',
                name: 'Metro Manila', 
                no: '50,000', 
                type: 'Restaurant', 
                imageUrl: 'https://img.kichieats.ph/top/search_by_area/metromanila.jpg',
                cities: [
                    { name: 'Caloocan', key: 'caloocan' },
                    { name: 'Las Piñas', key: 'las piñas' },
                    { name: 'Makati', key: 'makati' },
                    { name: 'Malabon', key: 'malabon' },
                    { name: 'Mandaluyong', key: 'mandaluyong' },
                    { name: 'Manila', key: 'manila' },
                    { name: 'Marikina', key: 'marikina' },
                    { name: 'Muntilupa', key: 'muntilipa' },
                    { name: 'Navotas', key: 'navotas' },
                    { name: 'Parañaque', key: 'parañaque' },
                    { name: 'Pasay', key: 'pasay' },
                    { name: 'Pasig', key: 'pasig' },
                    { name: 'Quezon City', key: 'quezon city' },
                    { name: 'San Juan', key: 'san juan' },
                    { name: 'Taguig', key: 'taguig' },
                    { name: 'Valenzuela', key: 'valenzuela' },
                    { name: 'Pateros', key: 'pateros' },
                ]
            },
            { 
                id: 2,
                key: 'boracay',
                name: 'Boracay', 
                no: '50,000', 
                type: 'Restaurant', 
                imageUrl: 'https://img.kichieats.ph/top/search_by_area/boracay.jpg' 
            },
            { 
                id: 3,
                key: 'makati',
                name: 'Makati', 
                no: '50,000', 
                type: 'Restaurant', 
                imageUrl: 'https://img.kichieats.ph/top/search_by_area/makati.jpg' 
            },
            { 
                id: 4,
                key: 'laguna',
                name: 'Laguna', 
                no: '50,000', 
                type: 'Restaurant', 
                imageUrl: 'https://img.kichieats.ph/top/search_by_area/laguna.jpg' 
            },
            { 
                id: 5,
                key: 'batangas',
                name: 'Batangas', 
                no: '50,000', 
                type: 'Restaurant', 
                imageUrl: 'https://img.kichieats.ph/top/search_by_area/batangas.jpg' 
            },
            {
                id: 6,
                key: 'rizal',
                name: 'Rizal', 
                no: '50,000', 
                type: 'Restaurant', 
                imageUrl: 'https://img.kichieats.ph/top/search_by_area/rizal.jpg' 
            },
            {
                id: 7,
                key: 'subic',
                name: 'Subic', 
                no: '50,000', 
                type: 'Restaurant', 
                imageUrl: 'https://img.kichieats.ph/top/search_by_area/subic.jpg' 
            },
            {  
                id: 8, 
                key: 'tagaytay',
                name: 'Tagaytay', 
                no: '50,000', 
                type: 'Restaurant', 
                imageUrl: 'https://img.kichieats.ph/top/search_by_area/tagaytay.jpg' 
            },
            {
                id: 9,
                key: 'cebu',
                name: 'Cebu', 
                no: '50,000', 
                type: 'Restaurant', 
                imageUrl: 'https://img.kichieats.ph/top/search_by_area/cebu.jpg',
                cities: [
                    { name: 'Cebu City', key: 'cebu' },
                    { name: 'Mandaue City', key: 'mandaue' },
                    { name: 'Lapu-Lapu City', key: 'lapu-lapu' },
                    { name: 'Talisay City', key: 'talisay' },
                    { name: 'Toledo City', key: 'toledo' },
                    { name: 'Danao City', key: 'danao' },
                    { name: 'Naga City', key: 'naga' },
                    { name: 'Carcar City', key: 'carcar' },
                ]
            },
            {
                id: 10,
                key: 'bgc',
                name: 'BGC', 
                no: '50,000', 
                type: 'Restaurant', 
                imageUrl: 'https://img.kichieats.ph/top/search_by_area/bgc.jpg' 
            }
        ]
    },
    {
        id: 1,
        slides: [
            { id: 11, key: 'bulacan', name: 'Bulacan', no: '50,000', type: 'Restaurant', imageUrl: 'https://img.kichieats.ph/top/search_by_area/bulacan.jpg' },
            { id: 12, key: 'davao', name: 'Davao', no: '50,000', type: 'Restaurant', imageUrl: 'https://img.kichieats.ph/top/search_by_area/davao_city.jpg' },
            { id: 13, key: 'iloilo', name: 'Iloilo', no: '50,000', type: 'Restaurant', imageUrl: 'https://img.kichieats.ph/top/search_by_area/iloilo.jpg' },
            { id: 14, key: 'palawan', name: 'Palawan', no: '50,000', type: 'Restaurant', imageUrl: 'https://img.kichieats.ph/top/search_by_area/palawan.jpg' },
            { id: 15, key: 'it-park', name: 'IT Park', no: '50,000', type: 'Restaurant', imageUrl: 'https://img.kichieats.ph/top/search_by_area/it_park.jpg' },
            { id: 16, key: 'pangasinan', name: 'Pangasinan', no: '50,000', type: 'Restaurant', imageUrl: 'https://img.kichieats.ph/top/search_by_area/pangasinan.jpg' },
            { id: 17, key: 'davao del sur', name: 'Davao del Sur', no: '50,000', type: 'Restaurant', imageUrl: 'https://img.kichieats.ph/top/search_by_area/davao_del_sur.jpg' },
            { id: 18, key: 'quezon', name: 'Quezon', no: '50,000', type: 'Restaurant', imageUrl: 'https://img.kichieats.ph/top/search_by_area/quezon.jpg' },
            { id: 19, key: 'angeles', name: 'Angeles', no: '50,000', type: 'Restaurant', imageUrl: 'https://img.kichieats.ph/top/search_by_area/angeles.jpg' },
            { id: 20, key: 'pampanga', name: 'Pampanga', no: '50,000', type: 'Restaurant', imageUrl: 'https://img.kichieats.ph/top/search_by_area/pampanga.jpg' }
        ]
    },
    {
        id: 2,
        slides: [
            { id: 21, key: 'zambales', name: 'Zambales', no: '50,000', type: 'Restaurant', imageUrl: 'https://img.kichieats.ph/top/search_by_area/zambales.jpg' },
            { id: 22, key: 'masbate', name: 'Masbate', no: '50,000', type: 'Restaurant', imageUrl: 'https://img.kichieats.ph/top/search_by_area/masbate.jpg' },
            { id: 23, key: 'misamis oriental', name: 'Misamis Oriental', no: '50,000', type: 'Restaurant', imageUrl: 'https://img.kichieats.ph/top/search_by_area/misamis.jpg' },
            { id: 24, key: 'bohol', name: 'Bohol', no: '50,000', type: 'Restaurant', imageUrl: 'https://img.kichieats.ph/top/search_by_area/bohol.jpg' },
            { id: 25, key: 'baguio', name: 'Baguio', no: '50,000', type: 'Restaurant', imageUrl: 'https://img.kichieats.ph/top/search_by_area/baguio.jpg' },
            { id: 26, key: 'isabela', name: 'Isabela', no: '50,000', type: 'Restaurant', imageUrl: 'https://img.kichieats.ph/top/search_by_area/isabela.jpg' },
            { id: 27, key: 'maguindanao', name: 'Maguindanao', no: '50,000', type: 'Restaurant', imageUrl: 'https://img.kichieats.ph/top/search_by_area/maguindanao.jpg' },
            { id: 28, key: 'cavite', name: 'Cavite', no: '50,000', type: 'Restaurant', imageUrl: 'https://img.kichieats.ph/top/search_by_area/antipolo.jpg' },
            { id: 29, key: 'cotabato', name: 'Cotabato', no: '50,000', type: 'Restaurant', imageUrl: 'https://img.kichieats.ph/top/search_by_area/cotabato.jpg' },
            { id: 30, key: 'more-places', name: 'More Places', no: '', type: 'Restaurant', imageUrl: 'https://img.kichieats.ph/top/search_by_area/more_places.png' }
        ]
    }
];

export const diningData: any = [
    {
        id: 1,
        name: "buffet"
    },
    {
        id: 2,
        name: "couple-date"
    },
    {
        id: 3,
        name: "family-bonding"
    },
    {
        id: 4,
        name: "reception"
    },
    {
        id: 5,
        name: "solo-dining"
    }
]

export const categoryData: any = [
    { id: 1, key: 'american', name: 'American', imageUrl: "https://img.kichieats.ph/top/categories/American.jpg" },
    { id: 2, key: 'bar', name: 'Bar', imageUrl: "https://img.kichieats.ph/top/categories/Bar.jpg" },
    { id: 3, key: 'bbq', name: 'BBQ', imageUrl: "https://img.kichieats.ph/top/categories/BBQ.jpg" },
    { id: 4, key: 'buffet', name: 'Buffet', imageUrl: "https://img.kichieats.ph/top/categories/Buffe.jpg" },
    { id: 5, key: 'burgers', name: 'Burgers', imageUrl: "https://img.kichieats.ph/top/categories/Burgers.jpg" },
    { id: 6, key: 'cafe', name: 'Cafe', imageUrl: "https://img.kichieats.ph/top/categories/Cafe.jpg" },
    { id: 7, key: 'cakes', name: 'Cakes', imageUrl: "https://img.kichieats.ph/top/categories/Cakes.jpg" },
    { id: 8, key: 'chicken', name: 'Chicken', imageUrl: "https://img.kichieats.ph/top/categories/Chicken.jpg" },
    { id: 9, key: 'china', name: 'China', imageUrl: "https://img.kichieats.ph/top/categories/China.jpg" },
    // { id: 10, key: 'dessert2', name: 'Dessert2', imageUrl: "https://img.kichieats.ph/top/categories/Dessert2.jpg" },
    { id: 11, key: 'fruits', name: 'Fruits', imageUrl: "https://img.kichieats.ph/top/categories/fruits.jpg" },
    { id: 12, key: 'hot-pot', name: 'Hot Pot', imageUrl: "https://img.kichieats.ph/top/categories/hot-pot.jpg" },
    { id: 13, key: 'indian', name: 'Indian', imageUrl: "https://img.kichieats.ph/top/categories/Indian.jpg" },
    // { id: 14, key: 'italian1', name: 'Italian1', imageUrl: "https://img.kichieats.ph/top/categories/Italian1.jpg" },
    { id: 15, key: 'izakaya', name: 'Izakaya', imageUrl: "https://img.kichieats.ph/top/categories/izakaya.jpg" },
    { id: 16, key: 'japanese', name: 'Japanese', imageUrl: "https://img.kichieats.ph/top/categories/japanese.jpg" },
    { id: 17, key: 'korean', name: 'Korean', imageUrl: "https://img.kichieats.ph/top/categories/Korean.jpg" },
    // { id: 18, key: 'korean2', name: 'Korean2', imageUrl: "https://img.kichieats.ph/top/categories/Korean2.jpg" },
    { id: 19, key: 'mexican', name: 'Mexican', imageUrl: "https://img.kichieats.ph/top/categories/Mexican.jpg" },
    { id: 20, key: 'philippine', name: 'Philippine', imageUrl: "https://img.kichieats.ph/top/categories/Philippine.jpg" },
    { id: 21, key: 'pizza', name: 'Pizza', imageUrl: "https://img.kichieats.ph/top/categories/Pizza.jpg" },
    { id: 22, key: 'ramen', name: 'Ramen', imageUrl: "https://img.kichieats.ph/top/categories/Ramen.jpg" },
    { id: 23, key: 'salad', name: 'Salad', imageUrl: "https://img.kichieats.ph/top/categories/salad.jpg" },
    { id: 24, key: 'samgyeopsal', name: 'Samgyeopsal', imageUrl: "https://img.kichieats.ph/top/categories/Samgyeopsal.jpg" },
    // { id: 25, key: 'seafood1', name: 'Seafood1', imageUrl: "https://img.kichieats.ph/top/categories/Seafood1.jpg" },
    { id: 26, key: 'shabushabu', name: 'Shabushabu', imageUrl: "https://img.kichieats.ph/top/categories/shabushabu.jpg" },
    // { id: 27, key: 'solo dining', name: 'solo dining', imageUrl: "https://img.kichieats.ph/top/categories/solo%20dining.jpg" },
    { id: 28, key: 'spicy', name: 'Spicy', imageUrl: "https://img.kichieats.ph/top/categories/spicy.jpg" },
    { id: 29, key: 'steak', name: 'Steak', imageUrl: "https://img.kichieats.ph/top/categories/Steak.jpg" },
    { id: 30, key: 'sushi', name: 'Sushi', imageUrl: "https://img.kichieats.ph/top/categories/sushi.jpg" },
    { id: 31, key: 'taiwan', name: 'Taiwan', imageUrl: "https://img.kichieats.ph/top/categories/Taiwan.jpg" },
    { id: 32, key: 'tonkatsu', name: 'Tonkatsu', imageUrl: "https://img.kichieats.ph/top/categories/Tonkatu.jpg" }
];

export const keywordData: any[] = [
    { 
        title: 'Keyword',
        items: [
            { name: 'Voucher available', key: 'voucher' },
            { name: 'Private rooms', key: 'private' },
            { name: 'Solo Dining', key: 'solo' },
            { name: 'Couple Date', key: 'couple' },
            { name: 'Family Dining', key: 'family' },
            { name: 'Reception', key: 'reception' },
            { name: 'Buffet', key: 'buffet' },
        ]
    },
    {
        title: 'Cuisine by Region',
        items: [
            { name: 'American', key: 'american' },
            { name: 'Filipino', key: 'filipino' },
            { name: 'Chinese', key: 'chinese' },
            { name: 'Indian', key: 'indian' },
            { name: 'Italian', key: 'italian' },
            { name: 'Japanese', key: 'japanese' },
            { name: 'Korean', key: 'korean' },
            { name: 'Mexican', key: 'mexican' },
            { name: 'Philippines', key: 'philippines' },
            { name: 'Taiwanese', key: 'taiwanese' },
            { name: 'Vietnam', key: 'vietnam' },
        ],
    },
    {
        title: 'Cuisine Type',
        items: [
            { name: 'BBQ', key: 'bbq' },
            { name: 'Buffet', key: 'buffet' },
            { name: 'Burgers', key: 'burgers' },
            { name: 'Chicken', key: 'chicken' },
            { name: 'Pizza', key: 'pizza' },
            { name: 'Ramen', key: 'ramen' },
            { name: 'Seafood', key: 'seafood' },
            { name: 'Steak', key: 'steak' },
            { name: 'Tonkatsu', key: 'tonkatsu' },
            { name: 'Samgyeopsal', key: 'samgyeopsal' },
            { name: 'Shabu Shabu', key: 'shabu-shabu' },
            { name: 'Hot Pot', key: 'hot-pot' },
        ],
    },
    {
        title: 'Dining Style',
        items: [
            { name: 'Bar', key: 'bar' },
            { name: 'Cafe', key: 'cafe' },
            { name: 'Izakaya', key: 'izakaya' },
        ],
    },
    {
        title: 'Desserts & Light Meals',
        items: [
            { name: 'Cakes', key: 'cakes' },
            { name: 'Desserts', key: 'desserts' },
            { name: 'Fruits', key: 'fruits' },
            { name: 'Salads', key: 'salads' },
            { name: 'Spicy', key: 'spicy' },
        ],
    },
    {
        title: 'Signature Dishes',
        items: [
            { name: 'Sushi', key: 'sushi' },
            { name: 'Steak', key: 'steak' },
        ],
    },
];


export const citiesData: any[] = [
    {
        title: 'Popular Areas',
        items: [
            { name: 'Boracay', key: 'boracay' },
            { name: 'Palawan', key: 'palawan' },
            { name: 'Siargao', key: 'siargao' },
            { name: 'Camiguin', key: 'camiguin' },
            { name: 'Bohol', key: 'bohol' },
            { name: 'BGC', key: 'bgc' },
            { name: 'Ortigas Center', key: 'ortigas center' },
            { name: 'Binondo', key: 'binondo' },
            { name: 'Intramuros', key: 'intramuros' },
            { name: 'Mactan Island', key: 'mactan island' },
            { name: 'Samal Island', key: 'samal island' },
            { name: 'Pagudpud', key: 'pagudpud' },
            { name: 'Zambales Beaches', key: 'zambales beaches' },
            { name: 'Subic Bay', key: 'subic-bay' },
            { name: 'Iloilo Business Park', key: 'iloilo business park' },
            { name: 'Ecoland', key: 'ecoland' },
            { name: 'Lanang', key: 'lanang' },
            { name: 'Session Road', key: 'session road' },
            { name: 'Burnham Park', key: 'burnham park' },
            { name: 'Nuvali', key: 'nuvali' },
            { name: 'Tagaytay Ridge', key: 'tagaytay ridge' },
            { name: 'Batangas Port Area', key: 'batangas port area' },
            { name: 'IT Park', key: 'it park' },
            { name: 'Fuente Osmeña Circle', key: 'fuente osmena circle' },
        ]
    },
    {
        title: 'National Capital Region (NCR) - Metro Manila',
        items: [
            { name: 'Caloocan', key: 'caloocan' },
            { name: 'Las Piñas', key: 'las-pinas' },
            { name: 'Makati', key: 'makati' },
            { name: 'Malabon', key: 'malabon' },
            { name: 'Mandaluyong', key: 'mandaluyong' },
            { name: 'Manila', key: 'manila' },
            { name: 'Marikina', key: 'marikina' },
            { name: 'Muntinlupa', key: 'muntinlupa' },
            { name: 'Navotas', key: 'navotas' },
            { name: 'Parañaque', key: 'paranaque' },
            { name: 'Pasay', key: 'pasay' },
            { name: 'Pasig', key: 'pasig' },
            { name: 'Quezon City', key: 'quezon city' },
            { name: 'San Juan', key: 'san juan' },
            { name: 'Taguig', key: 'taguig' },
            { name: 'Valenzuela', key: 'valenzuela' },
            { name: 'Pateros', key: 'pateros' },
        ]
    },
    {
        title: 'CALABARZON (Region IV-A) - Southern Luzon',
        items: [
            { name: 'Antipolo City', key: 'antipolo city' },
            { name: 'Bacoor City', key: 'bacoor city' },
            { name: 'Batangas City', key: 'batangas city' },
            { name: 'Biñan City', key: 'binan city' },
            { name: 'Cabuyao City', key: 'cabuyao city' },
            { name: 'Calamba City', key: 'calamba city' },
            { name: 'Cavite City', key: 'cavite city' },
            { name: 'Dasmariñas City', key: 'dasmarinas city' },
            { name: 'General Trias City', key: 'general trias city' },
            { name: 'Imus City', key: 'imus city' },
            { name: 'Lipa City', key: 'lipa city' },
            { name: 'Lucena City', key: 'lucena city' },
            { name: 'San Pablo City', key: 'san pablo city' },
            { name: 'San Pedro City', key: 'san pedro city' },
            { name: 'Santa Rosa City', key: 'santa rosa city' },
            { name: 'Tagaytay City', key: 'tagaytay city' },
            { name: 'Tanauan City', key: 'tanauan city' },
            { name: 'Tayabas City', key: 'tayabas city' },
            { name: 'Trece Martires City', key: 'trece martires city' },
        ]
    },
    {
        title: 'Central Visayas (Region VII) – Cebu and Surrounding Areas',
        items: [
            { name: 'Cebu City', key: 'cebu city' },
            { name: 'Mandaue City', key: 'mandaue city' },
            { name: 'Lapu-Lapu City', key: 'lapu-lapu city' },
            { name: 'Talisay City', key: 'talisay city' },
            { name: 'Toledo City', key: 'toledo city' },
            { name: 'Danao City', key: 'danao city' },
            { name: 'Naga City', key: 'naga city' },
            { name: 'Carcar City', key: 'carcar city' },
            { name: 'Tagbilaran City', key: 'tagbilaran city' },
            { name: 'Dumaguete City', key: 'dumaguete city' },
            { name: 'Bais City', key: 'bais city' },
            { name: 'Canlaon City', key: 'canlaon city' },
            { name: 'Guihulngan City', key: 'guihulngan city' },
            { name: 'Tanjay City', key: 'tanjay city' },
            { name: 'Larena', key: 'larena' },
        ]
    },
    {
        title: 'Davao Region (Region XI)',
        items: [
            { name: 'Davao City', key: 'davao city' },
            { name: 'Panabo City', key: 'panabo city' },
            { name: 'Tagum City', key: 'tagum city' },
            { name: 'Samal City', key: 'samal city' },
            { name: 'Mati City', key: 'mati city' },
            { name: 'Digos City', key: 'digos city' },
        ]
    },
    {
        title: 'Central Luzon (Region III)',
        items: [
            { name: 'Angeles City', key: 'angeles city' },
            { name: 'Olongapo City', key: 'olongapo city' },
            { name: 'San Fernando City (Pampanga)', key: 'san fernando city pampanga' },
            { name: 'Tarlac City', key: 'tarlac city' },
            { name: 'Balanga City', key: 'balanga city' },
            { name: 'Cabanatuan City', key: 'cabanatuan city' },
        ]
    },
    {
        title: 'Bicol Region (Region V)',
        items: [
            { name: 'Legazpi City (Albay)', key: 'legazpi city albay' },
            { name: 'Naga City (Camarines Sur)', key: 'naga city camarines sur' },
            { name: 'Sorsogon City (Sorsogon)', key: 'sorsogon city sorsogon' },
        ]
    },
    {
        title: 'Ilocos Region (Region I)',
        items: [
            { name: 'Vigan City (Ilocos Sur)', key: 'vigan city ilocos sur' },
            { name: 'San Fernando City (La Union)', key: 'san fernando city la union' },
            { name: 'Dagupan City (Pangasinan)', key: 'dagupan city pangasinan' },
        ]
    },
    {
        title: 'Cagayan Valley (Region II)',
        items: [
            { name: 'Tuguegarao City (Cagayan)', key: 'tuguegarao city cagayan' },
            { name: 'Ilagan City (Isabela)', key: 'ilagan city isabela' },
            { name: 'Cauayan City (Isabela)', key: 'cauayan city isabela' },
        ]
    },
    {
        title: 'Northern Mindanao (Region X)',
        items: [
            { name: 'Cagayan de Oro City', key: 'cagayan de oro city' },
            { name: 'Iligan City (Lanao del Norte)', key: 'iligan city lanao del norte' },
            { name: 'Ozamiz City (Misamis Occidental)', key: 'ozamiz city misamis occidental' },
        ]
    },
    {
        title: 'Cordillera Region (CAR)',
        items: [
            { name: 'Baguio City (Benguet)', key: 'baguio city benguet' },
            { name: 'Tabuk City (Kalinga)', key: 'tabuk city kalinga' },
            { name: 'La Trinidad (Benguet)', key: 'la trinidad benguet' },
        ]
    },
    {
        title: 'Eastern Visayas (Region VIII)',
        items: [
            { name: 'Tacloban City (Leyte)', key: 'tacloban city leyte' },
            { name: 'Ormoc City (Leyte)', key: 'ormoc city leyte' },
            { name: 'Calbayog City (Samar)', key: 'calbayog city samar' },
        ]
    },
    {
        title: 'Zamboanga Peninsula (Region IX)',
        items: [
            { name: 'Zamboanga City', key: 'zamboanga city' },
            { name: 'Dipolog City (Zamboanga del Norte)', key: 'dipolog city zamboanga del norte' },
            { name: 'Pagadian City (Zamboanga del Sur)', key: 'pagadian city zamboanga del sur' },
        ]
    },
    {
        title: 'BARMM (Bangsamoro Region)',
        items: [
            { name: 'Cotabato City (Maguindanao)', key: 'cotabato city maguindanao' },
            { name: 'Marawi City (Lanao del Sur)', key: 'marawi city lanao del sur' },
            { name: 'Lamitan City (Basilan)', key: 'lamitan city basilan' },
        ]
    },
    {
        title: 'Mimaropa (Region IV-B)',
        items: [
            { name: 'Puerto Princesa City (Palawan)', key: 'puerto princesa city palawan' },
            { name: 'San Jose (Occidental Mindoro)', key: 'san jose occidental mindoro' },
            { name: 'Calapan City (Oriental Mindoro)', key: 'calapan city oriental mindoro' },
        ]
    },
    {
        title: 'CARAGA (Region XIII)',
        items: [
            { name: 'Butuan City (Agusan del Norte)', key: 'butuan city agusan del norte' },
            { name: 'Surigao City (Surigao del Norte)', key: 'surigao city surigao del norte' },
            { name: 'Tandag City (Surigao del Sur)', key: 'tandag city surigao del sur' },
        ]
    },
    {
        title: 'Soccsksargen (Region XII)',
        items: [
            { name: 'General Santos City', key: 'general santos city' },
            { name: 'Koronadal City (South Cotabato)', key: 'koronadal city south cotabato' },
            { name: 'Kidapawan City (North Cotabato)', key: 'kidapawan city north cotabato' },
        ]
    },
    {
        title: 'Western Visayas (Region VI)',
        items: [
            { name: 'Iloilo City (Iloilo)', key: 'iloilo city' },
            { name: 'Bacolod City (Negros Occidental)', key: 'bacolod city negros occidental' },
            { name: 'Kalibo (Aklan)', key: 'kalibo aklan' },
        ]
    },
] 

export const seatOption = [
    {
        label: '1',
        value: 1
    },
    {
        label: '2',
        value: 2
    },
    {
        label: '3',
        value: 3
    },
    {
        label: '4',
        value: 4
    },
    {
        label: '5',
        value: 5
    },
    {
        label: 'More than 5',
        value: 6
    },
]